import type {Theme} from '../theme';
import {createBaseThemeVariation} from './base';

export const KidoTheme: Theme = createBaseThemeVariation({
    name: 'kido',
    brandColor: 'hsla(210, 100%, 20%, 1)',
    primaryColors: {
        p50: 'hsla(210, 100%, 98%, 1)',
        p75: 'hsla(210, 100%, 97%, 1)',
        p100: 'hsla(210, 100%, 96%, 1)',
        p200: 'hsla(210, 100%, 90%, 1)',
        p300: 'hsla(210, 100%, 70%, 1)',
        p400: 'hsla(210, 100%, 20%, 1)',
        p500: 'hsla(210, 100%, 10%, 1)',
    },
});
